import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core';
import { _MSGTYPES } from '../../constant/msgType';
import { TemplateService } from '../../services/template.service';
import { deepCopy } from '@delon/util';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-tpl-header',
  styles: [
    `
      .add-tpl {
        margin-left: 20px;
        color: #36bc99;
        font-weight: bold;
        font-size: 20px;
        cursor: pointer;
      }
      .biz-type-title {
        position: relative;
        z-index: 0;
        display: flex;
        align-items: center;
        width: calc(100% + 40px);
        height: 60px;
        margin-top: -20px;
        margin-bottom: 0;
        margin-left: -20px;
        padding-left: 20px;
        font-size: 18px;
        border-bottom: 1px solid #e8e8e8;
      }
      :host ::ng-deep .biz-type-icon {
        margin-right: 20px;
      }
    `,
  ],
  template: `
    <p class="biz-type-title">
      <ng-content></ng-content>
      {{ msgName }}模板 ({{ source.templates && source.templates.length ? source.templates.length : 0 }})
      <span class="iconfont icon-add add-tpl" (click)="addTemplate()" nz-popover [nzPopoverContent]="addTpl" nzPopoverPlacement="top"></span>
      <ng-template #addTpl>
        添加模板
      </ng-template>
    </p>
  `,
})
export class IccTplHeaderComponent implements OnInit {
  @Input() type: number;
  @Input() template: any;
  @Output() update = new EventEmitter<any>();

  /** 当前消息类型的资源 */
  source: any;
  /** 消息类型名称 */
  msgName: string;
  /** 辅助 --消息类型 */
  _MSGTYPES = _MSGTYPES;

  constructor(private templateService: TemplateService) {}

  ngOnInit() {
    this.source = this.templateService.getMsg(this.type) || [];
    this.msgName = this._MSGTYPES.getMsgByType(false, this.type).name;
  }
  /** 添加模板 */
  addTemplate() {
    const target = this.process();
    this.templateService.addTemplate(target, this.type);
    this.update.next();
  }
  /** 模板预处理 */
  process() {
    const templates = this.templateService.getTpl(this.type);
    const standardTemplate = this.templateService.getStandardTpl(this.type);
    let count = templates.length + 1;
    return {
      ...deepCopy(standardTemplate),
      bizTypeId: this.source.id,
      msgType: this.type,
      // count,
      name: '模板名称' + count,
    };
  }
}
